import { render, staticRenderFns } from "./selectPermissionTreeDialog.vue?vue&type=template&id=b8cabb22&scoped=true&"
import script from "./selectPermissionTreeDialog.vue?vue&type=script&lang=js&"
export * from "./selectPermissionTreeDialog.vue?vue&type=script&lang=js&"
import style0 from "./selectPermissionTreeDialog.vue?vue&type=style&index=0&id=b8cabb22&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cabb22",
  null
  
)

export default component.exports